import { useCallback } from 'react';

import { ImagePickerResult, useImagePicker } from './usePickImage';
import { FileNotSupported } from '../errors';
import { getTypeFromBase64 } from '../services';

export const usePickCoverPhoto = (
	onChange: (result: ImagePickerResult) => Promise<void> | void,
) => {
	const handlePickerResult = useCallback(
		(result: ImagePickerResult) => {
			const type = result.type || getTypeFromBase64(result.uri);
			if (type !== 'image') {
				throw new FileNotSupported();
			}

			return onChange(result);
		},
		[onChange],
	);
	const openImagePicker = useImagePicker(handlePickerResult, {
		allowsEditing: true,
		aspect: [1, 1],
	});

	return () => openImagePicker('gallery');
};
